let ctx;
let pinkBuf;

const pinkNoise = (ac, seconds) => {
  if (pinkBuf) return pinkBuf;
  const buf = ac.createBuffer(1, Math.floor(ac.sampleRate * seconds), ac.sampleRate);
  const d = buf.getChannelData(0);
  let b0 = 0, b1 = 0, b2 = 0, b3 = 0, b4 = 0, b5 = 0, b6 = 0;
  for (let i = 0; i < d.length; i++) {
    const w = Math.random() * 2 - 1;
    b0 = 0.99886 * b0 + w * 0.0555179;
    b1 = 0.99332 * b1 + w * 0.0750759;
    b2 = 0.969 * b2 + w * 0.153852;
    b3 = 0.8665 * b3 + w * 0.3104856;
    b4 = 0.55 * b4 + w * 0.5329522;
    b5 = -0.7616 * b5 - w * 0.016898;
    d[i] = (b0 + b1 + b2 + b3 + b4 + b5 + b6 + w * 0.5362) * 0.11;
    b6 = w * 0.115926;
  }
  pinkBuf = buf;
  return buf;
};

const rnd = (a, b) => a + Math.random() * (b - a);

const noiseVoice = (ac, out, { start, dur, type, from, to, q, peak, attack, release }) => {
  const src = ac.createBufferSource();
  src.buffer = pinkNoise(ac, 2);
  src.loop = true;
  src.loopStart = rnd(0, 1.2);
  src.loopEnd = src.loopStart + 0.6;
  const f = ac.createBiquadFilter();
  f.type = type;
  f.Q.value = q;
  f.frequency.setValueAtTime(from, start);
  f.frequency.exponentialRampToValueAtTime(to, start + dur);
  const g = ac.createGain();
  g.gain.setValueAtTime(0.0001, start);
  g.gain.exponentialRampToValueAtTime(peak, start + attack);
  g.gain.setValueAtTime(peak, start + Math.max(attack, dur - release));
  g.gain.exponentialRampToValueAtTime(0.0001, start + dur);
  src.connect(f).connect(g).connect(out);
  src.start(start, src.loopStart);
  src.stop(start + dur + 0.02);
};

export const playPageFlip = () => {
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    ctx = ctx || new AC();
    if (ctx.state === "suspended") ctx.resume().catch(() => {});
    const t = ctx.currentTime + 0.01;
    const speed = rnd(0.95, 1.1);

    const master = ctx.createGain();
    master.gain.value = 2.4;
    master.connect(ctx.destination);

    // 1. Breeze: a soft, airy whisper that lifts the sheet
    const sweep = 0.48 * speed;
    noiseVoice(ctx, master, { start: t, dur: sweep, type: "bandpass", from: 1200, to: 2600, q: 0.6, peak: 0.14, attack: 0.16, release: 0.22 });
    noiseVoice(ctx, master, { start: t + 0.04, dur: sweep, type: "highpass", from: 3500, to: 6000, q: 0.4, peak: 0.035, attack: 0.18, release: 0.2 });

    // 2. Melody: two tiny chime notes, like a wind chime brushed by the breeze
    const base = [1046.5, 1174.7, 1318.5, 1568][Math.floor(Math.random() * 4)];
    [[0.06, base, 0.028], [0.2, base * 1.5, 0.02]].forEach(([at, freq, vol]) => {
      const osc = ctx.createOscillator();
      osc.type = "sine";
      osc.frequency.value = freq;
      const og = ctx.createGain();
      og.gain.setValueAtTime(0.0001, t + at);
      og.gain.exponentialRampToValueAtTime(vol, t + at + 0.02);
      og.gain.exponentialRampToValueAtTime(0.0001, t + at + 0.45);
      osc.connect(og).connect(master);
      osc.start(t + at);
      osc.stop(t + at + 0.5);
    });

    // 3. Settle: the sheet comes to rest, barely audible
    noiseVoice(ctx, master, { start: t + sweep - 0.04, dur: 0.09, type: "lowpass", from: 1400, to: 700, q: 0.7, peak: 0.05, attack: 0.02, release: 0.06 });
  } catch (e) {
    /* audio not available */
  }
};
